const mediaGallery = Array.from(document.querySelectorAll(".product__media li"));

const isProductPage = document.querySelector(".template--product");

const productMedia = new Swiper(".product__media", {
  watchOverflow: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  preventInteractionOnTransition: true,
  effect: 'fade',
    fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
  navigation: {
    nextEl: '.product-media__inner .swiper-button-next',
    prevEl: '.product-media__inner .swiper-button-prev',
  }
});

console.log("This is the product page")

if (isProductPage) {
  const productHasLength = document.querySelector(".product-form__input--length");
  
  const selectedVariantColor = document.querySelector(".product-form__color").textContent
  const selectedVariantColorHandle = selectedVariantColor.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

  if (productHasLength) {
    const selectedVariantLength = document.querySelector("input[name='Length']:checked").value
    const selectedVariantLengthHandle = selectedVariantLength.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

    selectedVariantHandle = selectedVariantColorHandle + "-" + selectedVariantLengthHandle
    
    console.log("Color: " + selectedVariantColorHandle)
    console.log("Length: " + selectedVariantLengthHandle)
    console.log("Variant: " + selectedVariantHandle)

    productMedia.removeAllSlides()

    mediaGallery.forEach((media, index) => {
      if (media.dataset.color === selectedVariantHandle) {
        console.log(media.dataset.color)
        productMedia.addSlide(index, media);
      }
    })
    
  } else {
    console.log("Color: " + selectedVariantColorHandle)

    productMedia.removeAllSlides()

    mediaGallery.forEach((media, index) => {
      if (media.dataset.color === selectedVariantColorHandle) {
        console.log(media.dataset.color)
        productMedia.addSlide(index, media);
      }
    })
  }
}


const instafeed = new Swiper(".instafeed", {
  slidesPerView: 1.5,
  watchOverflow: false,
  watchSlidesVisibility: true,
  spaceBetween: 16,
  navigation: {
    nextEl: '.instafeed__buttons .swiper-button-next',
    prevEl: '.instafeed__buttons .swiper-button-prev',
  },
  breakpoints: {
    600: {
      slidesPerView: 3,
       spaceBetween: 24
    }
  }
});

const htmlTag = document.querySelector("html")
const toggleNav = document.querySelector("#hamburger")

if (toggleNav) {
  toggleNav.addEventListener("click", function (event) {
    htmlTag.classList.toggle("menu-open")
  })
}



const header = document.querySelector(".template--index .section-header")

const toggleHeader = function () {
  const pixels = window.pageYOffset
  
  if (pixels > 80) {
    header.classList.add("white")
  } else {
    header.classList.remove("white")
  }
}


if (header) {
  toggleHeader()

  
  document.addEventListener("scroll", function () {
    toggleHeader()
  })
}


        